module.exports = __webpack_public_path__ + "static/media/vehicle-type-scooter-white.42f90659.svg";